import EventEmitter from 'events'


import config from './config'

// tableau d'association des données à l'objet, dans l'ordre de la réponse
const assocArray = ['state', 'working', 'auto', 'mode', 'ventilation', 'pas', 'estime', 'total', 'duration', 'timer', 'temperatureSetpoint', 'temperature', 'humidity']
const assocArray_V2 = ['state', 'working', 'auto', 'mode', 'ventilation', 'pas', 'estime', 'total', 'duration', 'timer', 'temperatureSetpoint', 'temperature', 'humidity', 'sensor']

const PATH_CLIENT = '/client'

// Class de communication avec le four
class OvenConnectWs extends EventEmitter {

    // constantes, noms des événements
    static EVENT_CONNECTED = 'connected'
    static EVENT_DATA = 'data' // mise à jour des données du four
    static EVENT_UPDATED = 'updated'

    // clés de modification
    static KEY_AUTO = 'auto'
    static KEY_MODE = 'mode'
    static KEY_STATE = 'veille'
    static KEY_START_STOP = 'marche'
    static KEY_DURATION = 'duration'
    static KEY_TEMPERATURE = 'consigne'
    static KEY_VENTILATION = 'ventilation'
    static KEY_PAS = 'pas'
    static KEY_ESTIME = 'estime'

    // nombres de données transmise par le four
    static DATA_NUM_V1 = 13
    static DATA_NUM_V2 = 14

    // propriétés
    // _ovenId
    _socket
    _data

    // objet contenant les données du four
    _dataObj = {
        state: -1,
        working: -1,
        auto: -1,
        mode: -1,
        ventilation: -1,
        pas: -1,
        estime: -1,
        duration: -1,
        timer: -1,
        total: -1,
        temperatureSetpoint: -1,
        temperature: -1,
        humidity: -1,
        sensor: -1
    }

    // constructeur de l'instance
    constructor(jwt, ovenId) {
        super()

        // this._ovenId = ovenId

        // initialise la connexion
        this._initSocket(jwt, ovenId)
    }

    // nouvelle entrée
    _newCommand(command, dataArray, firstData, message) {

        console.log('SOCKET <-', message)

        switch (command) {
            case 'oven':
                this.emit(OvenConnectWs.EVENT_CONNECTED, true)
                break;
            case 'data':
                this._newData(dataArray)
                break;
            case 'recette':
                this._newRecipe(dataArray)
                break;
        }

    }

    _initSocket(jwt, ovenId) {

        var protocole = 'ws'
        if (config.secure) {
            protocole = 'wss'
        }

        var socket = new WebSocket(
            protocole + "://" + config.server_domain + PATH_CLIENT
        );

        // socket dans l'objet
        this._socket = socket
        var inst = this

        // erreur de connexion
        socket.onerror = error => {
            inst.emit(OvenConnectWs.EVENT_CONNECTED, false)
            console.error(error);
        };

        // fermeture
        socket.onclose = event => {
            inst.emit(OvenConnectWs.EVENT_CONNECTED, false)
        };

        // connction websocket établie
        socket.onopen = event => {

            // écouteur des nouveaux messages
            var listener = (event) => {
                var dataArray = event.data.split(' ')
                this._newCommand(dataArray.shift(), dataArray, dataArray[0], event.data)
            }

            /*
                        // deuxieme écouteur de validation de selection de four
                        var secondListener = (event) => {
            
                            if (event.data === 'oven') {
                                console.log('second ' +event.data)
                                // met le vrai socket
                                socket.onmessage = listener
                                // emet que le four est connecté
                                this.emit(OvenConnectWs.EVENT_OVEN_SELECTED, event.data)
                            }
                        }
                        */

            // premier écouteur qui attend "connected"
            var firstListener = (event) => {
                if (event.data === 'connected') {
                    // enregistre l'écouteur de commandes
                    socket.onmessage = listener
                    // séléctionne le four
                    this.sendKeyValue('oven', ovenId)

                }
            }
            socket.onmessage = firstListener

            // authentification
            this.sendKeyValue('auth', jwt)

        }


    }

    // tue
    kill() {
        this._removeListeners()
        this.stop()
    }

    // supprime les écouteur
    _removeListeners() {
        this.removeAllListeners()
    }

    // coupe la connexion
    stop() {
        if (this._socket) {
            this._socket.close()
        }
    }

    send(message) {
        this._socket.send(message)
        console.log('SOCKET ->', message)
    }


    sendKeyValue(key, value) {
        this.send(key + ' ' + value)
    }

    // envoi une valeur en ligne
    /*
    push(key, value) {
        if (this._socket) {
            this._socket.send(key + ' ' + value)
        }
    }
    */

    // nouvelles données
    _newData(dataArray) {

        // nombre de données correspondant à la version
        if (dataArray.length == OvenConnectWs.DATA_NUM_V1) {
            this._newData_V1(dataArray)
        }

        // nombre de données correspondant à la version
        else if (dataArray.length == OvenConnectWs.DATA_NUM_V2) {
            this._newData_V2(dataArray)
        }

    }

    _newData_V1(dataArray) {

        // clean les données
        for (var i = 0; i < dataArray.length; i++) {
            dataArray[i] = Number.parseInt(dataArray[i]) + ''
        }

        var change = false
        // remplissage de l'objet et déclenchement des événements
        var updatedData = {}
        var changedData = {}
        for (var num in assocArray) {
            var key = assocArray[num]
            updatedData[key] = dataArray[num]

            // comparaison
            if (this._dataObj[key] != dataArray[num]) {
                changedData[key] = dataArray[num]
                change = true
                // mise à jour
                this._dataObj[key] = dataArray[num]
            }
        }

        // envoi tout en événement
        if (change) {
            this.emit(OvenConnectWs.EVENT_UPDATED, changedData)
        }
    }



    _newData_V2(dataArray) {
        // clean les données
        for (var i = 0; i < dataArray.length; i++) {
            dataArray[i] = Number.parseInt(dataArray[i]) + ''
        }

        var change = false
        // remplissage de l'objet et déclenchement des événements
        var updatedData = {}
        var changedData = {}
        for (var num in assocArray_V2) {
            var key = assocArray_V2[num]
            updatedData[key] = dataArray[num]

            // comparaison
            if (this._dataObj[key] != dataArray[num]) {
                changedData[key] = dataArray[num]
                change = true
                // mise à jour
                this._dataObj[key] = dataArray[num]
            }
        }

        // envoi tout en événement
        if (change) {
            this.emit(OvenConnectWs.EVENT_UPDATED, changedData)
        }
    }



    // nouvelle recette séléctionnée
    _newRecipe(dataArray) {
        var recipeNumber = dataArray[0];
        var recipeName = dataArray[1];

        // décode le nom
        recipeName = recipeName.split("+").join(" ");

        // objet de retour
        var data = {
            recipeNumber: recipeNumber,
            recipeName: recipeName
        }

        this.emit(OvenConnectWs.EVENT_UPDATED, data)


    }

}
// module
export default OvenConnectWs